/**
 * React component for rendering a ticker using Swiper.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for rendering the ticker.
 * @returns {JSX.Element} The rendered Ticker component.
 */

import React from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";

// import required modules
import { Autoplay, EffectFade } from "swiper/modules";

import Image from "next/image";

// TODO(ROSHAN): ANCHOR
const Ticker = ({ data }) => {
  const TICKER_ITEMS = Object.entries(data?.heyMaticCleanThisTicker || {});

  return (
    <div className="w-full px-[24px] lg:px-0 flex justify-center items-center overflow-hidden">
      <div className="homePageSwiper border border-primary rounded-[8px] lg:rounded-[16px] bg-white w-full h-[80px] md:w-[560px] lg:w-[640px] md:h-[160px] px-[16px] lg:pl-[40px] lg:pr-[30px]">
        <Swiper
          spaceBetween={30}
          effect={"fade-out"}
          loop={true}
          direction={"vertical"}
          centeredSlides={true}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          modules={[EffectFade, Autoplay]}
        >
          {TICKER_ITEMS.map(([key, value]) => (
            <SwiperSlide key={key}>
              <div
                className={`h-full rounded-[16px] flex flex-row gap-[16px] md:gap-[26px] items-center`}
              >
                <div
                  className={`w-[60px] h-[45px] md:w-[120px] md:h-[92px] flex items-center`}
                >
                  <Image
                    priority
                    src={value.imageLink}
                    fill
                    alt={key}
                    className="custom-img"
                  />
                </div>
                <div className="flex flex-col gap-[6px] md:gap-[12px] items-start">
                  <div className={`eyebrow-bold mob:!text-[12px]`}>
                    {value.timeText}
                  </div>
                  <h4 className="whitespace-nowrap leading-[100%]">
                    {value.actionText}
                  </h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Ticker;
